import { render, staticRenderFns } from "./ViolationForm.vue?vue&type=template&id=4a85bf84&"
import script from "./ViolationForm.vue?vue&type=script&lang=ts&"
export * from "./ViolationForm.vue?vue&type=script&lang=ts&"
import style0 from "./ViolationForm.vue?vue&type=style&index=0&id=4a85bf84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports